/**
 * Initialize Google Analytics dynamically based on environment
 */

let gaInitialized = false;

export const initializeGA = (measurementId) => {
  if (gaInitialized) {
    console.log('Google Analytics already initialized');
    return;
  }

  if (!measurementId) {
    console.warn('No GA measurement ID provided');
    return;
  }

  try {
    // Load the gtag script dynamically
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);

    // Wait for script to load, then configure
    script.onload = () => {
      if (window.gtag) {
        // Store the measurement ID globally for analytics utility to use
        window.GA_MEASUREMENT_ID = measurementId;
        
        // Configure GA with the environment-specific ID
        window.gtag('config', measurementId, {
          send_page_view: true,
          debug_mode: process.env.NODE_ENV === 'development'
        });

        gaInitialized = true;
        
        // Send initialization event
        window.gtag('event', 'ga_initialized', {
          environment: process.env.REACT_APP_ENV || 'development'
        });
      }
    };

    script.onerror = () => {
      console.error('Failed to load Google Analytics script');
    };
  } catch (error) {
    console.error('Error initializing Google Analytics:', error);
  }
};

export default initializeGA;

